import { motion } from "framer-motion";
import { CHECKS, GOLD } from "./data";

const pop = { initial: { opacity: 0, scale: 0.85, y: 20 }, animate: { opacity: 1, scale: 1, y: 0 }, transition: { type: "spring", stiffness: 220, damping: 20 } };

export function Scan({ scanned }) {
  return (
    <div className="text-center" data-testid="engine-spot-scan">
      <div className="relative mx-auto h-40 w-40">
        {[0, 1, 2].map((i) => (
          <motion.span key={i} className="absolute inset-0 rounded-full border" style={{ borderColor: GOLD }}
            animate={{ scale: [0.3, 1.4], opacity: [0.8, 0] }} transition={{ duration: 2.4, repeat: Infinity, delay: i * 0.8 }} />
        ))}
        <div className="absolute inset-0 grid place-items-center text-[10px] tracking-[0.3em] text-white/60">THE HIVE</div>
      </div>
      <div className="mt-6 text-4xl font-black tabular-nums" style={{ color: GOLD }} data-testid="engine-scanned">{scanned.toLocaleString()}</div>
      <div className="text-xs tracking-[0.3em] text-white/40">SIGNALS READ TODAY</div>
    </div>
  );
}

export function Surface({ t }) {
  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid="engine-spot-surface">
      <motion.div {...pop} className="rounded-2xl border border-[#F5C451]/40 bg-[#141005] p-5">
        <div className="text-[10px] tracking-[0.3em] text-[#F5C451]">HIVE ALERT</div>
        <div className="mt-2 text-3xl font-black">${t.sym}</div>
        <div className="mt-2 text-sm text-white/60">{t.buyers} unique buyers · ${t.mcap}k mcap · called by {t.kol}</div>
      </motion.div>
      <motion.div {...pop} transition={{ ...pop.transition, delay: 0.5 }} className="rounded-2xl border border-sky-400/40 bg-sky-950/30 p-5">
        <div className="text-[10px] tracking-[0.3em] text-sky-300">GROK READ</div>
        <div className="mt-2 text-3xl font-black text-sky-200">{t.grok}<span className="text-base text-white/40">/100</span></div>
        <div className="mt-2 text-sm text-white/60">Organic chatter rising, real accounts, narrative fresh.</div>
      </motion.div>
    </div>
  );
}

export function Verify({ t }) {
  return (
    <div className="max-w-md mx-auto space-y-2" data-testid="engine-spot-verify">
      <div className="text-xs tracking-[0.3em] text-white/40 mb-3">VERIFYING ${t.sym}</div>
      {CHECKS.map((c, i) => (
        <motion.div key={c} initial={{ opacity: 0, x: -16 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.35 + i * 0.55 }}
          className="flex items-center gap-3 rounded-lg border border-white/10 bg-white/[0.03] px-4 py-2 text-sm">
          <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.6 + i * 0.55, type: "spring" }}
            className="h-5 w-5 rounded-full grid place-items-center text-[11px] font-black text-black" style={{ background: GOLD }}>✓</motion.span>
          <span className="text-white/75">{c}</span>
        </motion.div>
      ))}
    </div>
  );
}
